module.exports = __webpack_public_path__ + "static/WEDDING E&M-262-ea5d7a1dbdb7c7c9456abe7b6d6d6036.jpg";